/*
 *
 * Package: `@dbh/reset-password-page`.
 *
 */const importResetPasswordPage=()=>import('./component-e03d20d5.js'/*  webpackChunkName: 'dbh.reset-password-page.component' */);// to avoid the exported code leaking into other pages and increasing the bundle
// size unappropriately.

export { importResetPasswordPage as default };
